import { render, staticRenderFns } from "./dashang.vue?vue&type=template&id=3c6f2ee8&scoped=true&"
import script from "./dashang.vue?vue&type=script&lang=js&"
export * from "./dashang.vue?vue&type=script&lang=js&"
import style0 from "./dashang.vue?vue&type=style&index=0&id=3c6f2ee8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f2ee8",
  null
  
)

export default component.exports